import React, { useState } from "react";
import UserContext from "./UserContext";
import { StorageServices } from "utils";



const UserContextProvider = ({ children }) => {
    const [masterData, setMasterData] = useState(null)

    let userToken = StorageServices.getToken()
    let currentUserData = StorageServices.getCurrentUser()
    const [token, setToken] = useState(userToken)
    const [currentUser, setCurrentUser] = useState(currentUserData)

    return (
        <UserContext.Provider value={{
            masterData, setMasterData,
            token, setToken,
            currentUser, setCurrentUser
        }}>
            {children}
        </UserContext.Provider>
    )
}

export default UserContextProvider